import { Grid } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { countries } from '~/shared/config/constants'
import { AutocompleteInput, DatePickerInput, TextInput } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type PassportProps = {
  disabled?: boolean
  skeletonShow?: boolean
}

export function Passport({ disabled, skeletonShow }: PassportProps) {
  const { t } = useTranslation()

  return (
    <Container data-testid='passport-form-container'>
      <ContainerTitle>{t('passport')}</ContainerTitle>

      <Grid container spacing={2.5}>
        <Grid xs={6}>
          <AutocompleteInput
            label='form.citizenship'
            placeholder='form.choose citizenship'
            name='citizenship'
            options={countries}
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='form.series and number'
            placeholder='form.enter series and number'
            name='passportNumber'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={4}>
          <DatePickerInput
            label='form.date of birth'
            placeholder='form.enter date of birth'
            name='birthDate'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={4}>
          <DatePickerInput
            label='form.date of issue'
            placeholder='form.enter date of issue'
            name='passportIssueDate'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={4}>
          <DatePickerInput
            label='form.expiry date'
            placeholder='form.enter expiry date'
            name='data.passportExpirationDate'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={12}>
          <TextInput
            label='form.place of birth'
            placeholder='form.enter place of birth'
            name='data.birthPlace'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
